import type { ReactNode } from "react";

import * as sx from "./chat.sx";

// The user's turn, shared by both Catalyst flows (agent + knowledge/model): a
// compact grey bubble with break-word body1 text, right-aligned in the thread.
export function UserBubble({ children }: { children: ReactNode }) {
  return (
    <sx.UserBubbleRoot>
      <sx.UserBubbleText>{children}</sx.UserBubbleText>
    </sx.UserBubbleRoot>
  );
}
